module.exports = __webpack_public_path__ + "img/fastpaytv_white.f39e944c.png";